export const CREATE_NEW_TEMPLATE = 'Create New Template';
export const EDIT_TEMPLATE = 'Edit Template';
export const SAVE = 'Save';
